import { render, staticRenderFns } from "./DetailedTotals.vue?vue&type=template&id=15f732a2&"
import script from "./DetailedTotals.vue?vue&type=script&lang=js&"
export * from "./DetailedTotals.vue?vue&type=script&lang=js&"
import style0 from "./DetailedTotals.vue?vue&type=style&index=0&id=15f732a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports